/** Lightweight guide route index (no article bodies) for SEO / schema. */

export type GuideRoute = {
  category: string;
  slug: string;
};

export const GUIDE_ROUTES: GuideRoute[] = [
  { category: "adoptionsintyg", slug: "blankett-och-krav" },
  { category: "adoptionsintyg", slug: "infor-besoket" },
  { category: "afs-allergiframkallande", slug: "infor-besoket" },
  { category: "afs-allergiframkallande", slug: "regler-och-kontroll" },
  { category: "afs-asbest-kvarts", slug: "infor-besoket" },
  { category: "afs-asbest-kvarts", slug: "regler-och-kontroll" },
  { category: "afs-bly", slug: "infor-besoket" },
  { category: "afs-bly", slug: "regler-och-kontroll" },
  { category: "afs-handintensivt", slug: "infor-besoket" },
  { category: "afs-handintensivt", slug: "regler-och-kontroll" },
  { category: "afs-klattring", slug: "infor-besoket" },
  { category: "afs-klattring", slug: "regler-och-kontroll" },
  { category: "afs-vibrationer", slug: "infor-besoket" },
  { category: "afs-vibrationer", slug: "regler-och-kontroll" },
  { category: "alkolas", slug: "guide" },
  { category: "au-pair", slug: "blankett-och-intygskrav" },
  { category: "au-pair", slug: "provtagning-och-rontgen" },
  { category: "diabetes", slug: "krav-och-bedomning" },
  { category: "diabetes", slug: "underlag-och-besok" },
  { category: "fallskarm", slug: "blankett-och-krav" },
  { category: "fallskarm", slug: "infor-besoket" },
  { category: "forstadagsintyg", slug: "infor-besoket" },
  { category: "forstadagsintyg", slug: "intyg-till-arbetsgivaren" },
  { category: "hjarta-karl", slug: "krav-och-bedomning" },
  { category: "hjarta-karl", slug: "underlag-och-besok" },
  { category: "hogre-behorighet", slug: "horselkrav" },
  { category: "hogre-behorighet", slug: "synintyg" },
  { category: "nattarbete", slug: "infor-besoket" },
  { category: "nattarbete", slug: "regler-och-kontroll" },
  { category: "oeuk", slug: "infor-besoket" },
  { category: "oeuk", slug: "krav-och-intyg" },
  { category: "oeuk", slug: "norge-eller-oeuk" },
  { category: "offshore-norge", slug: "infor-besoket" },
  { category: "offshore-norge", slug: "krav-och-intyg" },
  { category: "ovriga-tillstand", slug: "krav-och-bedomning" },
  { category: "ovriga-tillstand", slug: "underlag-och-besok" },
  { category: "sjofolk", slug: "giltighetstid" },
  { category: "sjofolk", slug: "horseltest" },
  { category: "sjofolk", slug: "infor-besoket" },
  { category: "sjofolk", slug: "intyg-och-registrering" },
  { category: "sjofolk", slug: "manila-stcw" },
  { category: "tavlingsintyg", slug: "blankett-och-krav" },
  { category: "tavlingsintyg", slug: "infor-besoket" },
  { category: "utlandsstudier-arbete", slug: "blankett-och-intygskrav" },
  { category: "utlandsstudier-arbete", slug: "provtagning-och-rontgen" },
];

export function findGuideRoute(category: string, slug: string): GuideRoute | null {
  return GUIDE_ROUTES.find((g) => g.category === category && g.slug === slug) ?? null;
}

export function guideHref(category: string, slug: string, lang: "sv" | "en"): string {
  return lang === "en" ? `/en/guides/${category}/${slug}` : `/guider/${category}/${slug}`;
}
